export enum DtcType {
  ReadActiveDTCVDDs = 'ReadActiveDTCVDDs',
}

export interface ActiveDtc {
  dtcName: string;
  dtcNameTranslationId: string;
  logicalLink: string;
}

export enum DiagStackStructureSemantic {
  FAULTREAD = 'FAULTREAD',
  VALUE = 'VALUE',
  ENUM = 'ENUM',
}
